import { AllowSocial } from '../utils/allow-social';

// player directive
//
//   <boxcast-player channel-id="channel_id" options="{ autostart: false, ... }" />
//
// makes sure the boxcast.js script (per config) is properly loaded, and then
// initializes the player widget for the specified channel with the specified
// configuration.

let module = angular.module('app.directives');

module.directive('boxcastPlayer', ($q, $timeout, $rootScope) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { channelId: '=', options: '=', mode: '=' },
    template: `<div id="{{playerElementId}}"></div>`, // XXX: HACK: need custom ID
    link: (scope, element, attrs) => {
      let options = scope.options || { autostart: false };
      options.disableMetrics = $rootScope.user.is_impersonating;
      options.disableRedirectRulesOnLoad = true;
      options.playInline = true;

      if (BOXCAST_JS_ENV && !options.env) {
        options.env = BOXCAST_JS_ENV;
        //options.debug = (options.env == 'dev');
      }

      const showSocialShare = AllowSocial(
        $rootScope.account.feature_flags,
        $rootScope.account,
        null
      );
      if (!showSocialShare) {
        options.showSocialShare = false;
      } else if (options.showSocialShare === undefined) {
        options.showSocialShare = true;
      }
      if (options.showSocialShare) {
        options.facebookAppId = FACEBOOK_APP_ID;
      } else {
        delete options.facebookAppId;
      }

      // Disable geoblock and password block (note that `null` doesn't work, we need something truthy)
      options.geoblock = {};
      options.cryptblock = {};

      // XXX: passing in an element reference directly barfs when multiple
      // videos on same screen.  Let's generate a random element ID here.
      scope.playerElementId = `player-${Math.random().toString(36).substring(8)}`;

      // Wait for the channel to become available; then load the
      // player (could take a few ticks if broadcast is resolved via promise)
      let loaded = false;
      let boxcastElement = null;
      let boxcastPlayer = null;
      scope.$watch('channelId', (channelId) => {
        if (channelId && !loaded) {
          boxcastElement = boxcast(`#${scope.playerElementId}`);
          if (scope.mode == 'highlight') {
            boxcastElement.loadHighlight(channelId, {
              ...options,
              onLoadPlayer: (player) => {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              },
            });
          } else {
            boxcastElement.loadChannel(channelId, {
              ...options,
              onLoadPlayer: (player) => {
                boxcastPlayer = player;
                options.onLoadPlayer && options.onLoadPlayer(player);
              },
            });
          }
          loaded = true;
        }
      });

      scope.$on('player:pause', () => boxcastPlayer && boxcastPlayer.pause());

      // Handle a custom refresh meta event to refresh all our metadata
      scope.$on('boxcast:refreshMeta', () => {
        if (boxcastElement) {
          boxcastElement._boxcast.model.Actions.RefreshSelectedBroadcastMeta();
        }
      });

      // Clean up after ourselves
      scope.$on('$destroy', () => {
        if (boxcastElement) {
          boxcastElement.unload();
        }
        element.remove();
      });
    },
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/directives/boxcast-player.js